/**
 * EventLayout
 * This is the main layout of the app
 */

import React, { Component } from "react"
import styled from "styled-components"
import LayoutContainer from "components/LayoutContainer"
import { Header, Body } from "./styles"
import Logo from "components/Logo"
import theme from "styles/theme-main"
import { ThemeProvider } from "styled-components"
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles"
import { MessageContainer, MessageIcon, MessageContent } from "styles/Common"
import Icon from "components/Icon"
import Text from "components/Text"
import {
  convertMUI,
  checkTextForEmail,
  generateCandidateTitle,
  generateCandidateDescription,
} from "utils/utils"
import {
  getSubdomainFromUrl,
  isProfileMode,
  isCandidXMode,
} from "utils/productUtils"
import { Helmet } from "react-helmet-async"
import Maintenance from "components/Maintenance"

const LogoContainerMobile = styled.div`
  display: none;
  width: 912px;
  max-width: 100%;
  margin: 0 auto;

  @media (max-width: 800px) {
    display: block;
  }
`

const LogoContainerDesktop = styled.div`
  display: none;
  width: 912px;
  max-width: 100%;
  margin: 0 auto;

  @media (min-width: 800px) {
    display: block;
  }
`

export const LAYOUT_NAME = "EventLayout"

class EventLayout extends Component {
  componentDidMount() {
    const subdomain = getSubdomainFromUrl()
    if (subdomain && !this.props.organization) {
      this.props.getOrganization(subdomain)
    }
  }

  render() {
    const props = this.props

    const { process } = props
    const success = process && process.status === "done"
    const isEventCheckin = props.match.params.hasOwnProperty("eventId")

    if (props.organization) {
      const orgtheme = JSON.parse(props.organization.themeConfiguration || "{}")
      theme.logoWidth = orgtheme.logoWidth
      theme.logoMargin = orgtheme.logoMargin
      if (orgtheme.headerBGcolour) {
        theme.colors.headerBGcolour = orgtheme.headerBGcolour
      } else {
        theme.colors.headerBGcolour = "#ffffff"
      }
      theme.typography.fonts.regular = "Europa"
      theme.colors.primary = orgtheme.secondary || theme.colors.secondary
      theme.colors.secondary = orgtheme.secondary || theme.colors.secondary
      theme.menuItems.active = theme.colors.secondary
      theme.menuItems.selected = theme.colors.secondary
      theme.buttons.primary.background = theme.colors.secondary
      if (isProfileMode()) {
        theme.buttons.secondary.background = theme.colors.secondary
      }
    }

    theme.colors.headerBGcolour = isProfileMode()
      ? theme.colors.profileHeader
      : theme.colors.headerBGcolour

    const muitheme = createTheme(convertMUI(theme))
    const logoURL = props.organization && props.organization.logoURL
    const mainStyle = {}

    const doublePixels = width => {
      let pixels = width && width.replace("px", "")
      return `${pixels * 2}px`
    }

    let title = generateCandidateTitle(props.organization, props.role)
    let description = generateCandidateDescription(
      props.organization,
      props.role
    )
    const time = new Date().getTime()

    return (
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={muitheme}>
          <div style={mainStyle}>
            <Helmet>
              <title>{title}</title>
              <meta name="title" content={title} />
              <meta name="description" content={description} />
            </Helmet>
            <Maintenance />
            <Header {...props} isEventCheckin={isEventCheckin}>
              <LogoContainerMobile>
                {logoURL && (
                  <Logo
                    logoURL={`${logoURL}?id=${time}}`}
                    logoWidth={theme.logoWidth}
                    logoMargin={theme.logoMargin}
                    large
                    variant={isCandidXMode && "rareHeader"}
                    path={false}
                  />
                )}
              </LogoContainerMobile>
              <LogoContainerDesktop>
                {logoURL && (
                  <Logo
                    logoURL={`${logoURL}?id=${time}}`}
                    logoWidth={doublePixels(theme.logoWidth)}
                    logoMargin={doublePixels(theme.logoMargin)}
                    large
                    variant={isCandidXMode && "rareHeader"}
                    path={false}
                  />
                )}
              </LogoContainerDesktop>
            </Header>

            {/* This displays a success or error message if the redux process module has showOn="EventLayout" */}
            {process && process.showOn === LAYOUT_NAME ? (
              <MessageContainer success={success} variant={"profile"}>
                <LayoutContainer>
                  <MessageContent success={success}>
                    <MessageIcon success={success}>
                      {success ? (
                        <Icon variant={"tick_circle"} />
                      ) : (
                        <Icon variant={"warning"} />
                      )}
                    </MessageIcon>
                    <Text variant={"message"}>
                      {checkTextForEmail(process.message)}
                    </Text>
                  </MessageContent>
                </LayoutContainer>
              </MessageContainer>
            ) : null}

            <Body hasMessage={process && process.showOn === LAYOUT_NAME}>
              {props.children}
            </Body>
          </div>
        </MuiThemeProvider>
      </ThemeProvider>
    )
  }
}

export default EventLayout
